export default () => {
    const languageSwitcher = document.querySelectorAll('.language-switcher');

    if (!languageSwitcher.length) {
        return;
    }

    const switcherToggler = (e) => {
        const {target} = e;
        
        if (!target.closest('.language-switcher__sub')) {
            e.preventDefault();
        }

        target.closest('.language-switcher').classList.toggle('active');
    }

    languageSwitcher.forEach(item => item.addEventListener('click', switcherToggler))
}
